import { ScenarioStatisticShortcut } from '../../../models/query/scenarioStatistics';
import { ShortcutType, IQueryShortcutOptions, TRootOptionsShortcutFnReturn } from '../../../models/query/scenarioStatistics/shortcuts';
import { ScenarioStatisticQuery } from '../../ScenarioStatisticQuery';
import { IScenarioStatisticsResponse } from '../../../models/portal';

export class ShortcutBase {
	public key: ScenarioStatisticShortcut;
	public type: ShortcutType;
	public scenarioStatisticQuery: ScenarioStatisticQuery;
	public getRootOptions(shortcutOptions: IQueryShortcutOptions): TRootOptionsShortcutFnReturn {
		return {};
	}
	getDirectResponse(shortcutOptions: IQueryShortcutOptions, scenarioStatistics: IScenarioStatisticsResponse): any {
		return undefined;
	}
	constructor(key: ScenarioStatisticShortcut, type: ShortcutType, scenarioStatisticQuery: ScenarioStatisticQuery) {
		this.key = key;
		this.type = type;
		this.scenarioStatisticQuery = scenarioStatisticQuery;
	}
}